import { controls } from "../../controls";

const rp621 = {
  label: "OSC 5.3",
  pageLabel: "OSC 5.3 -Top 20 Performing borrowers",
  starting: true,
  url: "rp621",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  
  
  filter: [

    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "OSC 5.3\nTop 20 Performing borrowers",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Name of the borrower",
        accessor: "descn",
        rwidth:"*"
      },
      {
        Header: "Limit/ loan Sanctioned->>Type of loan",
        accessor: "loan_type",
        rwidth:"*"
      },
      {
        Header:"Limit/ loan Sanctioned->>Date of sanction",
        accessor: "opendate",    
        type:"date",
        width: 100,
        rwidth: 50 
      },
      {
        Header: "Limit/ loan Sanctioned->>Amount sanctioned",
        accessor: "sanction",
        type:"currency",
        width: 100,
        rwidth: 50  
      },
      {
        Header: "Limit/ loan Sanctioned->>Amount disbursed",
        accessor: "disbamt",
        type:"currency",
        width: 100,
        rwidth: 50
      },
      {
        Header: "Limit/ loan Sanctioned->>Outstanding",
        accessor: "balance",
        type:"currency",
        width: 100,
        rwidth: 50
      },
      {
        Header: "Value of security",
        accessor: "ValueSecurity",
        type:"currency",
        width: 100,
        rwidth: 50  
      },
      {
        Header:"If overdue, date of overdue",
        accessor: "od_date",    
        type:"date",
        width: 100,
        rwidth: 50  
      },       
      {
        Header: "Overdue Amount",
        columns: [
          {
            Header: "Principal",
            accessor: "od_princ",
            type:"currency",
            width: 100,
            rwidth: 50  
          },
          {
            Header: "Interest",
            accessor: "od_penal",
            type:"currency",
            width: 100,
            rwidth: 50
          }
        ]
      }
    ]
  }
};

export default rp621;